// Generate realistic order data for analytics
export function generateAnalyticsOrders(restaurantId: string = '1') {
  const statuses = ['delivered', 'preparing', 'out_for_delivery', 'confirmed', 'pending', 'cancelled'];
  const paymentMethods = ['upi', 'card', 'cash', 'wallet'];
  const customerNames = [
    'Neha Verma', 'Rahul Singh', 'Anita Desai', 'Vikram Malhotra', 'Priya Sharma',
    'Amit Patel', 'Sneha Reddy', 'Karan Joshi', 'Divya Nair', 'Rohan Gupta',
    'Kavya Iyer', 'Arjun Mehta', 'Pooja Kumar', 'Sanjay Kapoor', 'Ritu Chopra'
  ];
  
  const menuItems = [
    { id: '1', name: 'Paneer Tikka', price: 280 },
    { id: '2', name: 'Chicken Tikka', price: 320 },
    { id: '3', name: 'Butter Chicken', price: 380 },
    { id: '4', name: 'Paneer Butter Masala', price: 320 },
    { id: '5', name: 'Dal Makhani', price: 260 },
    { id: '6', name: 'Butter Naan', price: 50 },
    { id: '7', name: 'Garlic Naan', price: 60 },
    { id: '8', name: 'Gulab Jamun', price: 120 },
    { id: '9', name: 'Biryani', price: 350 },
    { id: '10', name: 'Raita', price: 80 },
  ];

  const orders = [];
  const now = Date.now();
  const daysBack = 30; // Generate orders for last 30 days

  // Generate 50-100 orders over the last 30 days
  const totalOrders = 75;

  for (let i = 0; i < totalOrders; i++) {
    // Random date within last 30 days
    const daysAgo = Math.floor(Math.random() * daysBack);
    const hoursAgo = Math.floor(Math.random() * 24);
    const minutesAgo = Math.floor(Math.random() * 60);
    const orderTime = now - (daysAgo * 24 * 60 * 60 * 1000) - (hoursAgo * 60 * 60 * 1000) - (minutesAgo * 60 * 1000);

    // Random customer
    const customer = customerNames[Math.floor(Math.random() * customerNames.length)];

    // Random items (1-4 items per order)
    const numItems = Math.floor(Math.random() * 3) + 1;
    const orderItems = [];
    let subtotal = 0;

    for (let j = 0; j < numItems; j++) {
      const item = menuItems[Math.floor(Math.random() * menuItems.length)];
      const quantity = Math.floor(Math.random() * 2) + 1;
      orderItems.push({
        id: item.id,
        menuItemId: item.id,
        name: item.name,
        price: item.price,
        quantity
      });
      subtotal += item.price * quantity;
    }

    // Calculate charges
    const deliveryFee = subtotal > 500 ? 0 : 40;
    const packagingCharges = 20;
    const taxRate = 0.05;
    const tax = Math.round(subtotal * taxRate);
    const discount = subtotal > 600 ? Math.round(subtotal * 0.1) : 0;
    const total = subtotal + deliveryFee + packagingCharges + tax - discount;

    // Status based on order age
    let status;
    if (daysAgo > 2) {
      // Old orders are mostly delivered or cancelled
      status = Math.random() > 0.15 ? 'delivered' : 'cancelled';
    } else if (daysAgo === 0 && hoursAgo < 1) {
      // Very recent orders
      const rand = Math.random();
      if (rand < 0.3) status = 'pending';
      else if (rand < 0.6) status = 'confirmed';
      else status = 'preparing';
    } else {
      // Recent orders
      status = statuses[Math.floor(Math.random() * statuses.length)];
    }

    // Rating only for delivered orders
    const rating = status === 'delivered' ? (Math.random() > 0.2 ? Math.floor(Math.random() * 2) + 4 : 3) : undefined;

    // Payment method and status
    const paymentMethod = paymentMethods[Math.floor(Math.random() * paymentMethods.length)];
    const paymentStatus = status === 'pending' && paymentMethod === 'cash' ? 'pending' : 'paid';

    orders.push({
      id: `ORD${String(i + 100).padStart(4, '0')}`,
      restaurantId,
      customerId: `cust_${Math.floor(Math.random() * 50) + 1}`,
      customerName: customer,
      customerPhone: `+91 ${Math.floor(Math.random() * 90000) + 10000} ${Math.floor(Math.random() * 90000) + 10000}`,
      customerAddress: `${Math.floor(Math.random() * 200) + 1}/${String.fromCharCode(65 + Math.floor(Math.random() * 26))}, Bangalore - ${Math.floor(Math.random() * 100000) + 500100}`,
      items: orderItems,
      subtotal,
      deliveryFee,
      packagingCharges,
      tax,
      discount,
      total,
      status,
      paymentMethod,
      paymentStatus,
      rating,
      createdAt: new Date(orderTime).toISOString(),
      updatedAt: new Date(orderTime + (Math.random() * 3600000)).toISOString(),
      estimatedDelivery: new Date(orderTime + (30 + Math.random() * 20) * 60000).toISOString(),
      assignedTo: status !== 'pending' ? '4' : undefined,
      notes: Math.random() > 0.7 ? 'Please make it less spicy' : undefined,
    });
  }

  return orders.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
}

// Initialize analytics data
export function initializeAnalyticsData() {
  const existingOrders = localStorage.getItem('orders');
  
  if (!existingOrders || JSON.parse(existingOrders).length < 20) {
    // Generate orders for restaurant 1 and 2
    const restaurant1Orders = generateAnalyticsOrders('1');
    const restaurant2Orders = generateAnalyticsOrders('2');
    
    const allOrders = [...restaurant1Orders, ...restaurant2Orders];
    localStorage.setItem('orders', JSON.stringify(allOrders));
    
    return allOrders;
  }
  
  return JSON.parse(existingOrders);
}
